import { tw } from "@careinfo/tailwind";
import { useForm } from "react-hook-form";
import Button from "../Reusable/Button";
import Form from "./Form";
import Card from "../Reusable/Card";
import { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { createInventoryInfovalidation } from "../../validation/InventoryInfo";
import PopupModal from "../Reusable/Modal";
import CreateUnit from "./CreateUnit";
import ProductGroupForm from "./ProductGroup";

const AddProduct = (props: any) => {
  const { handleCreate, isPostLoading } = props;
  const [openUnitFormPopup, setOpenUnitFormPopup] = useState(false);
  const [openCategoryFormPopup, setOpenCategoryFormPopup] = useState(false);
  const {
    handleSubmit,
    setValue,
    getValues,
    clearErrors,
    register,
    setError,
    watch,
    control,
    formState: { errors },
  } = useForm<any>({
    resolver: yupResolver(createInventoryInfovalidation),
    defaultValues: {
      is_taxable: true,
    },
  });
  const openingQuantity = watch("opening_quantity");
  const openingRate = watch("opening_rate");

  useEffect(() => {
    const quantity = parseFloat(openingQuantity);
    const rate = parseFloat(openingRate);
    if (!isNaN(quantity) && !isNaN(rate)) {
      const openingValue = quantity * rate;
      setValue("opening_balance", openingValue);
    } else {
      setValue("opening_balance", "");
    }
  }, [openingQuantity, openingRate]);

  return (
    <>
      <Card>
        <form
          onSubmit={handleSubmit((data) => handleCreate(data, setError))}
          className={tw`px-4`}
        >
          <Form
            control={control}
            register={register}
            errors={errors}
            setValue={setValue}
            watch={watch}
            setOpenCategoryFormPopup={setOpenCategoryFormPopup}
            setOpenUnitFormPopup={setOpenUnitFormPopup}
            getValues={getValues}
            clearErrors={clearErrors}
          />
          <div className={tw`flex w-full justify-end`}>
            <div className={tw`w-24 flex gap-x-4 items-center`}>
              <Button label="Save" isLoading={isPostLoading} />
            </div>
          </div>
        </form>
      </Card>
      <PopupModal
        title="Create unit"
        isOpen={openUnitFormPopup}
        setIsOpen={setOpenUnitFormPopup}
      >
        <CreateUnit setOpenUnitFormPopup={setOpenUnitFormPopup} />
      </PopupModal>
      <PopupModal
        title="Create Category"
        isOpen={openCategoryFormPopup}
        setIsOpen={setOpenCategoryFormPopup}
      >
        <div className={tw`min-w-[400px]`}>
          <ProductGroupForm
            setOpenCategoryFormPopup={setOpenCategoryFormPopup}
          />
        </div>
      </PopupModal>
    </>
  );
};

export default AddProduct;
